<div class="product-detail-component">
  <div class="header">
    <div class="left-pane">
      <label class="product-name">{{ lampName }}</label>
      <label class="product-cost">ca. {{ cost | number: '1.0-0' : 'es' }} €</label>
      <div [ngSwitch]="isKam">
        <label *ngSwitchCase="true" class="label">{{ 'module.energyMap.lampCard.vkText' | translate }}</label>
        <label *ngSwitchDefault class="label">{{ 'module.energyMap.lampCard.uvpText' | translate }}</label>
      </div>
      <label class="manufacturer">({{ manufacturer }})</label>
    </div>
    <div class="right-pane">
      <button class="alternate-button" (click)="showCatalog()">
        <span class="fa fa-retweet" aria-hidden="true"></span>
        <label class="ptr button-label"> {{ 'module.energyMap.productDetail.alternativeText' | translate }}</label>
      </button>
    </div>
  </div>

  <div class="details-pane">
    <div class="instruction-pane">
      <label class="instruction-label">{{ 'module.energyMap.productDetail.instructionText' | translate }}</label>
    </div>
    <div class="product-details">
      <div class="left-details-pane">
        <div class="details">
          <div class="row row-1">
            <label class="lbl number">{{ 'module.energyMap.productDetail.numberText' | translate }}</label>
            <label class="lbl-value number-value">{{ number }}</label>
          </div>
          <div class="row row-2">
            <label class="lbl manufacturer">{{ 'module.energyMap.productDetail.manufacturerText' | translate }}</label>
            <label class="lbl-value manufacturer-value">{{ manufacturer }}</label>
          </div>
          <div class="row row-3">
            <label class="lbl wattage">{{ 'module.energyMap.productDetail.wattageText' | translate }}</label>
            <label class="lbl-value wattage-value">{{ wattage }} W</label>
          </div>
          <div class="row row-4">
            <label class="lbl luminousColour">{{ 'module.energyMap.productDetail.luminuousColorText' | translate }}</label>
            <label class="lbl-value luminousColour-value">{{ luminousColour | number: '1.0-0' : 'es' }} K</label>
          </div>
          <div class="row row-5" *ngIf="luminousFlux > 0">
            <label class="lbl luminousFlux">{{ 'module.energyMap.productDetail.luminousFluxText' | translate }}</label>
            <label class="lbl-value luminousFlux-value">{{ luminousFlux | number: '1.0-0' : 'es' }} lm</label>
          </div>
          <div class="row row-6">
            <label class="lbl warrantyPeriod">{{ 'module.energyMap.productDetail.warrantyPeriodText' | translate }}</label>
            <label class="lbl-value warrantyPeriod-value">{{ warrantyPeriod }} Jahre</label>
          </div>
          <div class="row row-7">
            <label class="lbl energySaving">{{ 'module.energyMap.productDetail.energySavingText' | translate }}</label>
            <label class="lbl-value energySaving-value"
              >ca. {{ energySaving | number: '1.0-0' : 'es' }}{{ 'module.energyMap.productDetail.energySavingUnitText' | translate }}</label
            >
          </div>
          <div class="row row-8">
            <label class="lbl co2Saving">{{ 'module.energyMap.productDetail.co2SavingText' | translate }}</label>
            <label class="lbl-value co2Saving-value"
              >ca. {{ co2Saving | number: '1.0-0' : 'es' }}{{ 'module.energyMap.productDetail.co2SavingUnitText' | translate }}</label
            >
          </div>
          <button class="ptr button-exchange" (click)="toggleLuminousity()"><span class="fa fa-exchange" aria-hidden="true"></span>{{ btnText }}</button>
        </div>
      </div>
      <div class="right-details-pane">
        <img alt="lamp-img" *ngIf="isValidImage" class="image" [attr.src]="lampImage | async" (error)="setDefaultImage()" />
        <div *ngIf="!isValidImage" class="default-image">
          <span class="fa fa-picture-o fa-4x"></span>
          <label class="default-image-label">{{ 'module.energyMap.productDetail.defaultImageLabel' | translate }}</label>
        </div>
      </div>
    </div>
  </div>

  <div class="actions-pane">
    <button class="btn btn-white -border-inverted" (click)="close()">{{ 'module.energyMap.productDetail.overviewText' | translate }}</button>
    <button class="btn btn-outline-primary -border-inverted" (click)="addLampsToGroup()">
      {{ 'module.energyMap.productDetail.buttonSuccessText' | translate }}
    </button>
  </div>
  <button class="btn btn-primary btn-close" (click)="close()">
    <img class="x-icon" alt="close-icon" src="../../../../assets/icons/close-icon-white.svg" />
  </button>
</div>
